import React from "react";
import { Inbox } from "lucide-react";

export function EmptyState({ icon: Icon = Inbox, title = "Nothing here yet", description, action, testId = "empty-state" }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-2 rounded-md border border-dashed border-border bg-surface py-16 text-center"
      data-testid={testId}
    >
      <Icon size={32} strokeWidth={1.5} className="text-text-muted" />
      <p className="font-heading text-sm font-semibold text-text-main">{title}</p>
      {description && <p className="max-w-sm text-xs text-text-muted">{description}</p>}
      {action}
    </div>
  );
}
